import { notificationApi } from "@core/ports/notifications";

import { GenerationPreviewSchema } from "./generation.ts";

export const generationNotificationApi = notificationApi({
  "generation:generation:status-update": GenerationPreviewSchema,
});
